var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0dcc5a8d01ae5cc1fe94a97873ada520b3e7666f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-app@groove"]={id:"0dcc5a8d01ae5cc1fe94a97873ada520b3e7666f"};
      